import React from 'react'
import { Link } from 'react-router-dom'

function experts() {
    return (
        <div>
            <header className="shadow-sm">
            {/* <div className="py-1 bg-blue-300"></div> */}
                <nav className="flex flex-wrap items-center justify-between px-8 py-4 mx-auto bg-white">
                <div className="flex items-center flex-shrink-0 mr-6 text-white">
                    <Link className="pl-2 text-white no-underline hover:text-white hover:no-underline" to="#">
                    <div className="block w-16 h-8 mx-auto bg-gray-500 rounded-sm"></div>
                    </Link>
                    <Link className="pl-2 text-white no-underline hover:text-white hover:no-underline" to="#">
                    <div className="block w-16 h-8 mx-auto bg-gray-500 rounded-sm"></div>
                    </Link>
                    <Link className="pl-2 text-white no-underline hover:text-white hover:no-underline" to="#">
                    <div className="block w-16 h-8 mx-auto bg-gray-500 rounded-sm"></div>
                    </Link>
                </div>

                <div className="block lg:hidden">
                    <button id="nav-toggle" className="focus:outline-none">
                        <div className="block w-8 h-1 mx-auto mb-1 bg-gray-300 rounded-sm"></div>
                        <div className="block w-8 h-1 mx-auto mb-1 bg-gray-300 rounded-sm"></div>
                        <div className="block w-8 h-1 mx-auto mb-1 bg-gray-300 rounded-sm"></div>
                    </button>
                </div>

                <div className="flex-grow hidden w-full pt-6 lg:flex lg:items-center lg:w-auto lg:block lg:pt-0" id="nav-content">
                    <ul className="items-center justify-end flex-1 list-reset lg:flex">
                    <li className="mr-3">
                        <Link className="inline-block px-4 py-2 no-underline active:text-gray-900" to="/">
                        <div className="block w-16 h-2 mx-auto mt-2 bg-gray-400 rounded-sm"></div>
                        </Link>
                    </li>
                    <li className="mr-3">
                        <Link className="inline-block px-4 py-2 text-gray-600 no-underline hover:text-gray-200 hover:text-underline" to="/">
                        <div className="block w-16 h-2 mx-auto mt-2 bg-gray-400 rounded-sm"></div>
                        </Link>
                    </li>
                    <li className="mr-3">
                        <Link className="inline-block px-4 py-2 text-gray-600 no-underline hover:text-gray-200 hover:text-underline" to="/">
                        <div className="block w-16 h-2 mx-auto mt-2 bg-gray-400 rounded-sm"></div>
                     </Link>
                    </li>
                    <li className="mr-3">
                        <Link className="inline-block px-4 py-2 text-gray-600 no-underline hover:text-gray-200 hover:text-underline" to="/">
                        <div className="block w-16 h-2 mx-auto mt-2 bg-gray-400 rounded-sm"></div>
                        </Link>
                    </li>
                    </ul>
                </div>
                </nav>
            </header>

            <main className="flex items-center justify-center flex-grow">

                <div className="px-4 py-2 mx-auto text-center sm:px-8">

                <div className="max-w-lg mx-auto mt-6 text-center">
                    <div className="block w-40 h-2 mx-auto bg-gray-500 rounded-sm"></div>
                    <h2 className="text-5xl font-semibold text-white md:text-9xl lg:text-8xl">Coming <span className="text-green-400">Soon</span></h2>
                    <div className="block w-64 h-2 mx-auto mt-4 bg-gray-400 rounded-sm"></div>
                    <div className="block w-48 h-2 mx-auto mt-2 bg-gray-400 rounded-sm"></div>
                </div>

                <div className="grid items-start grid-cols-6 gap-4 px-8 mx-auto mt-8">

                    <div className="col-span-6 sm:col-span-6 md:col-span-3 lg:col-span-2 xl:col-span-2">
                    <div className="px-4 py-6 mx-4 my-4 bg-white rounded-lg shadow-lg">
                        <div className="h-40 mx-auto bg-gray-200 rounded-md"></div>
                        <div className="block w-40 h-4 mx-auto mt-8 bg-gray-200 rounded-sm"></div>
                        <div className="block w-64 h-2 mx-auto mt-2 bg-gray-200 rounded-sm"></div>
                        <div className="flex justify-center mt-4">
                        <div className="w-20 h-8 px-4 mr-2 bg-gray-200 rounded-sm"></div>
                        <div className="w-20 h-8 px-4 bg-green-300 rounded-sm"></div>
                        </div>
                    </div>
                    </div>


                    <div className="col-span-6 sm:col-span-6 md:col-span-3 lg:col-span-2 xl:col-span-2">
                    <div className="px-4 py-6 mx-4 my-4 bg-white rounded-lg shadow-lg">
                        <div className="h-40 mx-auto bg-gray-200 rounded-md"></div>
                        <div className="block w-40 h-4 mx-auto mt-8 bg-gray-200 rounded-sm"></div>
                        <div className="block w-64 h-2 mx-auto mt-2 bg-gray-200 rounded-sm"></div>
                        <div className="flex justify-center mt-4">
                        <div className="w-20 h-8 px-4 mr-2 bg-gray-200 rounded-sm"></div>
                        <div className="w-20 h-8 px-4 bg-green-300 rounded-sm"></div>
                        </div>
                    </div>
                    </div>

                    <div className="col-span-6 sm:col-span-6 md:col-span-6 lg:col-span-2 xl:col-span-2">
                    <div className="px-4 py-6 mx-4 my-4 bg-white rounded-lg shadow-lg">
                        <div className="h-40 mx-auto bg-gray-200 rounded-md"></div>
                        <div className="block w-40 h-4 mx-auto mt-8 bg-gray-200 rounded-sm"></div>
                        <div className="block w-64 h-2 mx-auto mt-2 bg-gray-200 rounded-sm"></div>
                        <div className="flex justify-center mt-4">
                        <div className="w-20 h-8 px-4 mr-2 bg-gray-200 rounded-sm"></div>
                        <div className="w-20 h-8 px-4 bg-green-300 rounded-sm"></div>
                        </div>
                    </div>
                    </div>

                </div>
                </div>

            </main>

        </div>
    )
}

export default experts
